import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createAppSlice, AppSlice } from './appSlice';
import { createAuthSlice, AuthSlice } from './authSlice';

export type CombinedSlice = AppSlice & AuthSlice;

export const useStore = create<CombinedSlice>()(
	devtools((...a) => ({
		...createAppSlice(...a),
		...createAuthSlice(...a),
	}))
);
